import { dayjsUtils } from '@src/shared/utils/helpers/dayjs';

export function getUserTimezone(): string {
  return typeof Intl !== 'undefined'
    ? Intl.DateTimeFormat().resolvedOptions().timeZone
    : '';
}

export function getCurrentScheduleFields() {
  const timezone = getUserTimezone();
  const now = dayjsUtils();

  return {
    scheduledDate: now.format('YYYY-MM-DD'),
    scheduledTime: now.format('HH:mm'),
    timezone,
  };
}
